'use client';

const getGameId = () => {
  if (typeof window === 'undefined') {
    console.log('Error: getGameId should only be used in client modules');
    return '0';
  }
  const match = window?.location.pathname.match(/\/games\/(\d+)/);
  return match ? match[1] : '0';
};

export default getGameId;
